
import { CardContent } from "@/components/ui/card";
import { BillsTable } from "./BillsTable";
import { BillStatusDialog } from "../BillStatusDialog";
import { BillsPagination } from "./BillsPagination";
import { InvoiceDialog } from "./InvoiceDialog";
import { AdminBill } from "./types";
import { useState } from "react";

interface BillsContentProps {
  bills: AdminBill[];
  loading: boolean;
  updating: boolean;
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onUpdateStatus: (billId: string) => void;
  onCancelBill: (billId: string) => void;
  selectedBillId: string | null;
  isDialogOpen: boolean;
  dialogAction: 'paid' | 'cancel';
  onDialogOpenChange: (open: boolean) => void;
  onDialogConfirm: () => void;
}

export function BillsContent({
  bills,
  loading,
  updating,
  totalPages,
  currentPage,
  onPageChange,
  onUpdateStatus,
  onCancelBill,
  selectedBillId,
  isDialogOpen,
  dialogAction,
  onDialogOpenChange,
  onDialogConfirm
}: BillsContentProps) {
  const [selectedBill, setSelectedBill] = useState<AdminBill | null>(null);
  const [isInvoiceDialogOpen, setIsInvoiceDialogOpen] = useState(false);

  const handleViewInvoice = (bill: AdminBill) => {
    setSelectedBill(bill);
    setIsInvoiceDialogOpen(true);
  };

  return (
    <CardContent>
      <div className="min-h-[200px]">
        {loading ? (
          <div className="text-center py-4">Loading bills...</div>
        ) : (
          <BillsTable 
            bills={bills}
            onUpdateStatus={onUpdateStatus}
            onCancelBill={onCancelBill}
            onViewInvoice={handleViewInvoice}
            disabled={updating}
          />
        )}
      </div>
      
      <BillsPagination 
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
      
      {selectedBillId && (
        <BillStatusDialog
          isOpen={isDialogOpen}
          onOpenChange={onDialogOpenChange}
          onConfirm={onDialogConfirm}
          billId={selectedBillId}
          action={dialogAction}
          isLoading={updating}
        />
      )}

      <InvoiceDialog
        bill={selectedBill}
        open={isInvoiceDialogOpen}
        onOpenChange={setIsInvoiceDialogOpen}
      />
    </CardContent>
  );
}
